/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../../common';
import AbstractInput from './AbstractInput';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.inputs.labels`;

export default class Text extends AbstractInput {
	className() {
		return `${super.className()} ${super.className()}--text`;
	}

	content() {
		const { name } = this.attrs;

		return [<label className="label">{t(`${prfx}.${name}`)}</label>, <input type="text" name={name} className="FormControl" bidi={this.value} />];
	}
}
